export const VIOLATION_TABLE_OPTION = [
  "rationale",
  "DocNum",
  "DocDate",
  "answered",
  "answerStatus",
  "federalArea",
  "dealerName",
  "deadline",
  "violationType",
  "reportedByUser",
  "subdivision",
  "category",
];
